import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  QueryList,
  ElementRef
} from '@angular/core';
import { NavigationItem } from './navigation-item.component';

/**
 * `SideNavMenu` provides a method to group `SideNavItem`s under a common heading.
 */
@Component({
  selector: 'suka-navigation-menu',
  template: `
    <li class="navigation__item navigation__item--icon">
      <button
        (click)="toggle()"
        class="navigation__sub-menu"
        aria-haspopup="true"
        [attr.aria-expanded]="expanded"
        type="button">
        <div class="navigation__icon">
          <ng-content select="suka-icon"></ng-content>
        </div>
        <span class="navigation__sub-menu-title">{{title}}</span>
        <suka-icon icon="chevron-down" class="navigation__sub-menu-icon"></suka-icon>
      </button>
      <ul class="navigation__menu" role="menu" [ngStyle]="{'max-height': expanded ? childrenHeight + 'px' : '0px'}">
        <ng-content></ng-content>
      </ul>
    </li>
  `
})
export class NavigationMenu implements AfterContentInit {
  /**
   * Heading for the group
   */
  @Input() title: string;
  /**
   * Controls the visibility of the child `SideNavItem`s
   */
  @Input() expanded = false;

  @ContentChildren(NavigationItem) navigationItems: QueryList<NavigationItem>;
  @ContentChildren(NavigationItem, { read: ElementRef }) navigationNativeItems: QueryList<ElementRef>;

  childrenHeight = 0;

  ngAfterContentInit() {
    setTimeout(() => {
      this.navigationItems.forEach(item => {
        item.isSubMenu = true;
      });
    });

    setTimeout(() => {
      this.navigationNativeItems.forEach(item => {
        item.nativeElement.children.forEach(children => {
           this.childrenHeight += children.offsetHeight;
        });
      });
    });
  }

  toggle() {
    this.expanded = !this.expanded;
  }
}
